import keyInsight from '../model/keyInsight'
import reportDataService from './reportDataService'
export default class keyInsightService {
  static getSampleLevel(sampleInsight, comparisonGroupRanges) {
    const rangeHigh = comparisonGroupRanges && comparisonGroupRanges.rangeHigh ? comparisonGroupRanges.rangeHigh : 0
    const rangeLow = comparisonGroupRanges && comparisonGroupRanges.rangeLow ? comparisonGroupRanges.rangeLow : 0
    let sampleLevel = null // undetected
    if ((comparisonGroupRanges === null || comparisonGroupRanges === undefined) && (sampleInsight === null || sampleInsight === undefined)) {
      sampleLevel = '?' // undetected
    } else if (!sampleInsight) {
      sampleLevel = null // undetected
    } else if (sampleInsight.abundance > rangeHigh) {
      sampleLevel = 1 // high
    } else if (rangeLow > sampleInsight.abundance) {
      sampleLevel = -1 // low
    } else {
      sampleLevel = 0 // average
    }
    return sampleLevel
  }

  static getLevelDescriptions(value, sampleInsight, comparisonGroupRanges, isSecondary = false, abundanceProperty) {
    const sampleData = {}
    sampleData.value = Number.parseFloat(sampleInsight ? sampleInsight[abundanceProperty].toFixed(2) : null)
    sampleData.level = this.getSampleLevel(sampleInsight, comparisonGroupRanges)

    sampleData.levelReading = `This sample reported ${sampleData.level!==null && sampleData.level!=='?' ? 'a' : 'undetected'} level`
    switch (sampleData.level) {
      case -1:
        sampleData.levelDescription = value.lowLevelDescription
        sampleData.levelDescriptionSpecialText = value.lowLevelDescriptionHighlight
        sampleData.levelReading += ' lower than '
        sampleData.levelReadingSpecialText = ' lower than '
        sampleData.shiftLevel = 'lower'
        break
      case 0:
        sampleData.levelDescription = value.averageLevelDescription
        sampleData.levelDescriptionSpecialText = value.averageLevelDescriptionHighlight
        sampleData.levelReading += ' similar to '
        sampleData.levelReadingSpecialText = ' similar to '
        sampleData.shiftLevel = 'similar'
        break
      case 1:
        sampleData.levelDescription = value.highLevelDescription
        sampleData.levelDescriptionSpecialText = value.highLevelDescriptionHighlight
        sampleData.levelReading += ' higher than '
        sampleData.levelReadingSpecialText = ' higher than '
        sampleData.shiftLevel = 'higher'
        break
      case '?':
        sampleData.levelDescription = 'Needs undetected level description..'
        sampleData.levelReading += ' similar to '
        sampleData.levelReadingSpecialText = ' similar to '
        break
      default:
        sampleData.levelDescription = 'Needs undetected level description..'
        sampleData.levelReading += ' unlike the healthy group'
        sampleData.levelReadingSpecialText = 'undetected level unlike the healthy group'
        break
    }

    sampleData.levelReading += sampleData.level !== null ? 'the healthy group' : ''
    sampleData.levelReadingSpecialText += sampleData.level !== null ? 'the healthy group' : ''

    return sampleData
  }

  static async getMetabolitesKeyInsights(comparisonQuery, primarySample, secondarySample) {
    let comparisonKeyInsightData = []
    let primarySampleMetabolitesData = null
    let secondarySampleMetabolitesData = null
    let returnData = []
    await reportDataService.getComparisonCompoundProfile(comparisonQuery)
      .then(response => {
        const data = response && response.data && response.data.compoundProfile ? Object.entries(response.data.compoundProfile).flat(Infinity) : []
        comparisonKeyInsightData = data.filter(comparisonKeyInsight => typeof comparisonKeyInsight === 'object')
      })

    await reportDataService.getMicrobialMetabolites(primarySample, secondarySample)
      .then(response => {
        primarySampleMetabolitesData = response.primarySample ? response.primarySample.value : []
        if (secondarySample) {
          secondarySampleMetabolitesData = response.secondarySample ? response.secondarySample.value : []
        }
      })

    keyInsight.filter(insight => insight.type === 'metabolite')
      .forEach(metaboliteItem => {
        const comparisonGroupRanges = this.getMetabolitesComparisonByKey(metaboliteItem.compoundProfileKey, comparisonKeyInsightData)
        const [primaryMetaboliteInsight] = primarySampleMetabolitesData.filter(data => data.key === metaboliteItem.compoundProfileKey)

        if (primaryMetaboliteInsight) {
          metaboliteItem.primary = this.getLevelDescriptions(metaboliteItem, primaryMetaboliteInsight, comparisonGroupRanges, false, 'abundance')
          metaboliteItem.levelIndicatorPositive = metaboliteItem.isBad.indexOf(metaboliteItem.primary.level) === -1 // Not found in the bad list is a positive thing.
          metaboliteItem.levelDescription = metaboliteItem.primary.levelDescription
          metaboliteItem.levelDescriptionHighlight = metaboliteItem.primary.levelDescriptionSpecialText
        }

        if (secondarySample) {
          const [secondaryMetaboliteInsight] = secondarySampleMetabolitesData.filter(data => data.key === metaboliteItem.compoundProfileKey)
          if (secondaryMetaboliteInsight) {
            metaboliteItem.secondary = this.getLevelDescriptions(metaboliteItem, secondaryMetaboliteInsight, comparisonGroupRanges, true, 'abundance')
            // Detect shifts
            metaboliteItem.levelDescription = metaboliteItem[metaboliteItem.primary.shiftLevel+metaboliteItem.secondary.shiftLevel]
            metaboliteItem.levelDescriptionHighlight = `${metaboliteItem[metaboliteItem.primary.shiftLevel+metaboliteItem.secondary.shiftLevel+"Highlight"]}`
          }
        }
        returnData.push(metaboliteItem)
      })
    return returnData
  }

  static async getMacronutrientsKeyInsights(comparisonQuery, primarySample, secondarySample) {
    let returnData = []
    let comparisonKeyInsightData = []
    let primarySampleMacronutrientData = []
    let secondarySampleMacronutrientData = []

    await reportDataService.getDataFromAPI(`/comparison/insight-xt/${comparisonQuery}/macronutrient-counts`, 'get')
      .then(response => {
        comparisonKeyInsightData = response.data && response.data.macronutrientComposition ? response.data.macronutrientComposition : []
      })

    await reportDataService.getMacronutrients(primarySample, secondarySample)
      .then(response => {
        primarySampleMacronutrientData = response.primarySample ? response.primarySample.value : []
        if (secondarySample) {
          secondarySampleMacronutrientData = response.secondarySample ? response.secondarySample.value : []
        }
      })

    keyInsight.filter(insight => insight.type === 'macronutrient')
      .forEach(macronutrientItem => {
        macronutrientItem.primary = this.getLevelDescriptions(macronutrientItem, primarySampleMacronutrientData[macronutrientItem.compoundProfileKey], comparisonKeyInsightData[macronutrientItem.compoundProfileKey], false, 'abundance')
        macronutrientItem.levelIndicatorPositive = macronutrientItem.isBad.indexOf(macronutrientItem.primary.level) === -1 // Not found in the bad list is a positive thing.
        macronutrientItem.levelDescription = macronutrientItem.primary.levelDescription
        macronutrientItem.levelDescriptionHighlight = macronutrientItem.primary.levelDescriptionSpecialText
        if (secondarySample) {
          macronutrientItem.secondary = this.getLevelDescriptions(macronutrientItem, secondarySampleMacronutrientData[macronutrientItem.compoundProfileKey], comparisonKeyInsightData[macronutrientItem.compoundProfileKey], true, 'abundance')
          
           // Detect shifts
          macronutrientItem.levelDescription = macronutrientItem[macronutrientItem.primary.shiftLevel+macronutrientItem.secondary.shiftLevel]
          macronutrientItem.levelDescriptionHighlight = `${macronutrientItem[macronutrientItem.primary.shiftLevel+macronutrientItem.secondary.shiftLevel+"Highlight"]}`
        }
        returnData.push(macronutrientItem)
      })
    return returnData
  }

  static async getSpeciesKeyInsights(comparisonQuery, primarySample, secondarySample) {
    let returnData = []
    let comparisonKeyInsightData = []
    let primarySampleSpeciesData = []
    let secondarySampleSpeciesData = []
    await reportDataService.getComparisonData('species', comparisonQuery)
      .then(response => {
        comparisonKeyInsightData = response && response.data && response.data.prokaryoteProfile ? response.data.prokaryoteProfile : []
      })

    await reportDataService.getSampleProfileSpecies(primarySample.identifier)
      .then(response => {
        primarySampleSpeciesData = response.data && response.data.abundanceProfile ? response.data.abundanceProfile : []
      })

    if (secondarySample) {
      await reportDataService.getSampleProfileSpecies(secondarySample.identifier)
        .then(response => {
          secondarySampleSpeciesData = response.data && response.data.abundanceProfile ? response.data.abundanceProfile : []
        })
    }

    keyInsight.filter(insight => insight.type === 'specie')
      .forEach(specie => {
        specie.primary = this.getLevelDescriptions(specie, primarySampleSpeciesData[specie.compoundProfileKey], comparisonKeyInsightData[specie.compoundProfileKey], false, 'abundance')
        specie.levelIndicatorPositive = specie.primary.level !== specie.isBad
        specie.levelDescription = specie.primary.levelDescription
        specie.levelDescriptionHighlight = specie.primary.levelDescriptionSpecialText

        if (secondarySample) {
          specie.secondary = this.getLevelDescriptions(specie, secondarySampleSpeciesData[specie.compoundProfileKey], comparisonKeyInsightData[specie.compoundProfileKey], true, 'abundance')
          specie.levelIndicatorPositive = specie.secondary.level !== specie.isBad
          specie.levelDescription = specie.secondary.levelDescription
          specie.levelDescriptionHighlight = specie.secondary.levelDescriptionSpecialText
        }
        returnData.push(specie)
      })


    return returnData
  }

  static async getKeyInsightData(primarySample = null, secondarySample = null, comparisonQuery = null) {
    if (!primarySample) throw new Error('primarySample is missing.')
    if (!comparisonQuery) throw new Error('comparisonQuery is missing.')
    let returnData = []

    await this.getMetabolitesKeyInsights(comparisonQuery, primarySample, secondarySample)
      .then(response => {
        returnData = [...returnData, ...response]
      })

    // await this.getSpeciesKeyInsights(comparisonQuery, primarySample, secondarySample)
    //   .then(response => {
    //     returnData = [...returnData, ...response]
    //   })

    await this.getMacronutrientsKeyInsights(comparisonQuery, primarySample, secondarySample)
      .then(response => {
        returnData = [...returnData, ...response]
      })
    return returnData
  }

  static getMetabolitesComparisonByKey(key, comparisonKeyInsightData) {
    let returnData = null
    if (comparisonKeyInsightData) {
      comparisonKeyInsightData.forEach(comparisonKeyInsight => {
        Object.entries(comparisonKeyInsight).forEach((value) => {
          const matchedMetabolite = value.find(val=>val.key===key)
          if(matchedMetabolite) {
            returnData = matchedMetabolite
            return
          }
        })
      })
    }
    return returnData
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@microbadevs/report/src/services/keyInsightService.js
// module id = fH41
// module chunks = 0